import { forwardRef, type HTMLAttributes } from 'react'
import { useIntl } from 'react-intl'

import { stringIsMessageId } from '@/l10n/stringIsMessageId'
import { cn } from '@/lib/utils'

import { useFormField } from './useFormField'

export const FormMessage = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
  ({ className, children, ...props }, ref) => {
    const intl = useIntl()
    const { error, formMessageId } = useFormField()

    if (!error?.message) {
      return null
    }

    const body = error.message
      ? stringIsMessageId(error.message)
        ? intl.formatMessage({ id: error.message })
        : error.message
      : children

    return (
      <p
        ref={ref}
        id={formMessageId}
        className={cn('text-sm font-medium text-red-500 select-none', className)}
        {...props}>
        {body}
      </p>
    )
  }
)
